import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { retrieveConvergencePageMenu } from "../../redux/slice/convergence/convergence-pages-menu-slice";
import { useDynamicScripts } from "../../hooks/useDynamicScript";
import { retrieveMasterPageConfiguration } from "../../redux/slice/master-page-configuration-slice";
import { RootState, useAppDispatch } from "../../redux/store";

const CertificationsHeader = (prop: { siteNavPath: string }) => {
  const dispatch = useAppDispatch();
  const path = prop.siteNavPath;
  const { masterPageConfigurationData } = useSelector((state: RootState) => state.masterPageConfiguration);
  const { ConvergencePagesMenuData } = useSelector((state: RootState) => state.ConvergencePageMenu);

  useEffect(() => {
    dispatch(retrieveConvergencePageMenu(path));
    dispatch(retrieveMasterPageConfiguration());
  }, [dispatch]);

  useDynamicScripts({ htmlScriptString: masterPageConfigurationData[0]?.masterPageData[0]?.globalScripts || "", divId: "globalScript" });

  return (
    <header id="site-header" className="site-header site-header-paddingCustom certifications-header" role="banner">
      <div className="container">
      <Navbar bg="light" className="navbar-light" expand="lg">
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {ConvergencePagesMenuData[0]?.navBarItemsList?.map((item, index) => {
              return item.childNavigation?.length === 0 ? (
                <Nav.Link href={item.url} key={index} target={item.isTargetBlank ? "_blank" : ""} dangerouslySetInnerHTML={{ __html: item.text }}></Nav.Link>
              ) : (
                <NavDropdown id="nav-dropdown-dark-example" title={item.text} menuVariant="dark" key={index}>
                  {item.childNavigation?.map((itm, indx) => {
                    return <NavDropdown.Item href={itm.url} key={indx} target={itm.isTargetBlank ? "_blank" : ""} dangerouslySetInnerHTML={{ __html: itm.text }}></NavDropdown.Item>;
                  })}
                </NavDropdown>
              );
            })}
          </Nav>
        </Navbar.Collapse>
        <div className="form-inline">
          <a className="navbar-brand" style={{ marginRight: 0 }} href="/">
            <img alt="RAPS.org" src="https://rapsprod.blob.core.windows.net/rapsk13/raps/media/homepage/rapssitelogo.png" />
          </a>
        </div>
        </Navbar>
      </div>
    </header>
  )
}

export default CertificationsHeader;